var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscoverCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 20,
  fill: "none",
  viewBox: "0 0 35 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 23,
  x: 0.5,
  y: 0.5,
  fill: "#fff",
  stroke: "#D9D9D9",
  rx: 3.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FD6020",
  d: "m15 23 19-5.75V20a3 3 0 0 1-3 3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M30.394 9.11c1.045 0 1.62.484 1.62 1.398.052.698-.418 1.29-1.045 1.397l1.41 1.988h-1.097l-1.202-1.935h-.104v1.935h-.889V9.11zm-.418 2.204h.26c.576 0 .837-.269.837-.752 0-.43-.261-.699-.836-.699h-.261zm-3.973 2.579h2.51v-.806h-1.621v-1.29h1.568v-.806h-1.568V9.917h1.62V9.11h-2.509zm-2.613-1.559-1.202-3.223h-.94L23.18 14h.47l1.934-4.89h-.94zm-10.61-.805c0 1.343 1.046 2.471 2.352 2.471.418 0 .784-.107 1.15-.269v-1.074c-.261.322-.627.537-1.045.537-.836 0-1.516-.645-1.516-1.504v-.108a1.59 1.59 0 0 1 1.464-1.665c.418 0 .836.215 1.097.537V9.379c-.313-.214-.732-.268-1.097-.268-1.36-.108-2.405 1.02-2.405 2.418m-1.62-.591c-.522-.215-.68-.323-.68-.591.053-.323.314-.591.628-.538.261 0 .523.161.732.376l.47-.644c-.366-.323-.836-.538-1.306-.538-.732-.053-1.36.538-1.412 1.29v.054c0 .644.262 1.02 1.098 1.289.209.054.418.161.627.269a.57.57 0 0 1 .261.483c0 .376-.313.699-.627.699H10.9c-.418 0-.784-.269-.94-.645l-.576.59c.314.592.941.914 1.568.914.836.054 1.516-.59 1.568-1.45v-.162c-.052-.644-.313-.967-1.359-1.396M8.13 13.892h.888V9.112H8.13zM4 9.112h1.567c1.255.054 2.248 1.128 2.196 2.418 0 .698-.314 1.343-.836 1.826-.47.376-1.045.591-1.62.538H4zm1.15 3.976c.418.053.888-.108 1.202-.377.313-.322.47-.752.47-1.235 0-.43-.157-.86-.47-1.182-.314-.269-.784-.43-1.202-.376h-.262v3.17z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FD6020",
  fillRule: "evenodd",
  d: "M18.948 9c-1.307 0-2.404 1.075-2.404 2.471 0 1.344 1.045 2.472 2.404 2.526s2.404-1.075 2.456-2.472C21.352 10.128 20.307 9 18.948 9",
  clipRule: "evenodd"
})));
export default SvgDiscoverCard;